<script setup lang="ts">
import { computed } from 'vue'

import { ICONS, type IconName } from '@/lib/icons'

const props = withDefaults(
  defineProps<{
    name: IconName
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
    strokeWidth?: number
  }>(),
  { size: 'md', strokeWidth: 1.75 },
)

const SIZE_CLASS = {
  xs: 'size-3.5',
  sm: 'size-4',
  md: 'size-5',
  lg: 'size-6',
  xl: 'size-8',
} as const

const component = computed(() => ICONS[props.name])
</script>

<template>
  <component
    :is="component"
    class="shrink-0"
    :class="SIZE_CLASS[size]"
    :stroke-width="strokeWidth"
    aria-hidden="true"
  />
</template>
